// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"99eee853eee8aba2601d","655":"2c9bea80244b1e971548"}[chunkId] + ".js";
};